// 카테고리 이미지 URL을 가져오는 유틸리티 함수
// optimized_image_url이 있으면 우선 사용하고, 없으면 image_url 사용
export const getCategoryImageUrl = (category: {
  optimized_image_url?: string | null;
  image_url?: string | null;
}): string | null => {
  return category.optimized_image_url || category.image_url || null;
};

// 카테고리 이미지가 없을 때 사용할 기본 이미지 URL 생성
export const getCategoryImageWithFallback = (
  category: {
    optimized_image_url?: string | null;
    image_url?: string | null;
    name?: string;
  },
  width: number = 400,
  height: number = 400
): string => {
  const imageUrl = getCategoryImageUrl(category);
  
  if (imageUrl) {
    return imageUrl;
  }
  
  // 기본 이미지 생성
  const categoryName = encodeURIComponent(String(category.name || ''));
  return `https://picsum.photos/${width}/${height}?text=${categoryName}`;
};

// 기본 프로필 이미지 목록 (확실한 의료진 이미지)
const DEFAULT_PROFILE_IMAGES = [
  'https://images.unsplash.com/photo-1612349317150-e413f6a5b16d?w=400&auto=format&fit=crop&q=60', // 남자 의사 1
  'https://images.unsplash.com/photo-1582750433449-648ed127bb54?w=400&auto=format&fit=crop&q=60', // 남자 의사 2
  'https://cdn.docdocdoc.co.kr/news/photo/201708/1045484_1106384_1015.jpg', // 도크도크독 의사 이미지
  '/images/doctors/doctor-hospital_1098-19685.png', // 로컬 의사 이미지 1 (새로 교체)
  '/images/doctors/uilyo-jongsajaleul-dadseubnida.jpg', // 로컬 의사 이미지 2
  'https://images.unsplash.com/photo-1559839734-2b71ea197ec2?w=400&auto=format&fit=crop&q=60', // 여자 의사 1
];

// 강연자 이미지를 처리하는 유틸리티 함수
// null이거나 person.png로 끝나는 경우 기본 이미지를 반환
export const getLecturerImageWithFallback = (
  imageUrl: string | null | undefined,
  lecturerId?: number
): string => {
  // 유효한 이미지 URL인지 확인
  const isValidImage = imageUrl && 
    imageUrl.trim() !== '' && 
    !imageUrl.endsWith('person.png');
  
  if (isValidImage) {
    return imageUrl;
  }
  
  // 기본 이미지 선택 (강연자 ID를 기준으로 일관되게)
  if (lecturerId) {
    const index = lecturerId % DEFAULT_PROFILE_IMAGES.length;
    return DEFAULT_PROFILE_IMAGES[index];
  }
  
  // ID가 없는 경우 첫 번째 이미지 사용
  return DEFAULT_PROFILE_IMAGES[0];
};
